import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  TreeSelectionsReducer,
} from './common.js';

const InlineDropdownSelectionsReducer = TreeSelectionsReducer;

const InlineDropdownSelectionsAggregator = ({ responses, question }) =>
  (responses || []).reduce((acc, response) => {
    const { choices } = question || {};
    const { data } = response || {};
    const { value } = data || {};
    const categoryIds = Object.keys(value || {}) || [];

    (categoryIds || []).forEach(categoryId => {
      const selections = acc[categoryId] || {};
      const choiceID = value[categoryId];
      const choiceCount = (selections[choiceID] || {}).count || 0;
      const categoryChoices = choices[categoryId];
      const choice =
        categoryChoices && categoryChoices.find(c => c.value === choiceID);

      acc[categoryId] = {
        ...selections,
        [choiceID]: {
          value: choice && choice.value,
          count: choiceCount + 1,
        },
      };
    });

    return acc;
  }, {});

export default {
  AggregateMap: GlobalAggregateMap(InlineDropdownSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(InlineDropdownSelectionsReducer),
};
